<div id="storage" class="printMe">
  <div *ngIf="report" style="width:22cm;padding:40px 40px;display:block;flex-direction: column;box-sizing:border-box;"
    class="report-gm-default-font">
    <div style="margin-top:8px;background-color:white;">
      <div fxLayout="row" id="header">
        <div id="inspectionInfo" fxLayout="column" style="width:30%;" fxLayoutAlign="start start">
          <span>{{inspectionService.report?.header.title}}</span>
          <span>{{inspectionService.report?.header.CustomerName}}</span>
          <span>{{inspectionService.report?.header.date}}</span>
          <span>Service Advisor: {{inspectionService.report?.header.AdvisorName}}</span>
        </div>
        <div id="vehicleInfo" fxLayout="column" fxLayoutAlign="start start" style="width:30%;">
          <span>{{inspectionService.report?.header.VehicleYear}}
            {{inspectionService.report?.header.VehicleModel}}</span>
          <span>Repair Order: {{inspectionService.report?.header.WorkOrderId}}</span>
          <span>Tag: {{inspectionService.report?.header.tag}}</span>
          <span>VIN: {{inspectionService.report?.header.Vin}}</span>
        </div>
        <div fxLayout="column" fxLayoutAlign="end end" style="width:40%">
          <img style="height:100px;width:auto;"
            [src]="inspectionService?.dealershipLogo" alt="Logo"
            crossOrigin>
        </div>
      </div>
      <div fxLayout="row" style="border:1px solid lightgray;margin-top:8px;padding:2px;width:100%;">
        <div fxLayout="row" style="width:170px">
          <div fxLayout="column">
            <mat-icon mat-font-set="material-icons" class="gm-mat-icon" style="color: #00C853; margin: 0 1px 0 0">
              check_circle</mat-icon>
          </div>
          <div fxLayout="column">
            <span style="padding-top:2px">Checked and OK</span>
          </div>
        </div>
        <div fxLayout="row" style="width:220px">
          <div>
            <mat-icon mat-font-set="material-icons" class="gm-mat-icon" style="color:#FFD600; margin:0 2px 0 0">
              warning</mat-icon>
          </div>
          <div fxLayout="column">
            <span style="padding-top:2px">Future Attention Requried</span>
          </div>
        </div>
        <div fxLayout="row" style="width:170px">
          <div fxLayout="column">
            <mat-icon mat-font-set="material-icons" class="gm-mat-icon" style="color:#D50000; margin:0 2px 0 0">report
            </mat-icon>
          </div>
          <div fxLayout="column">
            <span style="padding-top:2px">Repair Required</span>
          </div>
        </div>
        <div fxLayout="row">
          <div fxLayout="column">
            <mat-icon mat-font-set="material-icons" class="gm-mat-icon" style="color:#000000;margin:0 2px 0 0">remove
            </mat-icon>
          </div>
          <div fxLayout="column">
            <span style="padding-top:2px">Not Inspected</span>
          </div>
        </div>
      </div>
      <div fxLayout="row">
        <div fxLayout="column" style="width:33%;margin-right:12px;">
          <div id="visualCheck">
            <span
              style="border-bottom:1px solid lightgray;font-size:16px;display:block;margin-top:16px; font-weight:bold">
              VISUALLY CHECK FOLLOWING COMPONENTS</span>
            <div
              *ngFor="let task of inspectionService.report?.categories?.VisuallyCheckFollowingComponents.tasks | orderBy: 'sequence'"
              fxLayout="row">
              <div *ngIf="task?.displayOilLife == 0" fxLayout="column">
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                  style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                  style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                  style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                  style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
              </div>
              <div *ngIf="task?.displayOilLife == 0" fxLayout="column" style="padding:2px">
                <span>{{task?.TaskName}}</span>
              </div>
            </div>
          </div>
          <div id="fluidLevels">
            <span
              style="border-bottom:1px solid lightgray;font-size:16px;display:block;margin-top:16px; font-weight:bold">CHECK
              FLUID LEVELS & FILL</span>
            <div
              *ngFor="let task of inspectionService.report?.categories?.CheckFluidLevelsFill.tasks | orderBy: 'sequence'"
              fxLayout="row">
              <div fxLayout="column">
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                  style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                  style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                  style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                  style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
              </div>
              <div fxLayout="row" style="padding:2px;width:100%;" fxLayoutAlign="space-between">
                <span>{{task?.TaskName}}</span>
                <span *ngIf="task?.fluidFilled == true">Filled</span>
              </div>
            </div>
          </div>
          <div id="checkBattery">
            <span
              style="border-bottom:1px solid lightgray;font-size:16px;display:block;margin-top:16px; font-weight:bold">CHECK
              BATTERY</span>
            <div *ngFor="let task of inspectionService.report?.categories?.CheckBattery.tasks | orderBy: 'sequence'"
              fxLayout="row">
              <div *ngIf="task?.displayBatteryVoltage == 0" fxLayout="column">
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                  style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                  style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                  style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                  style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
              </div>
              <div *ngIf="task?.displayBatteryVoltage == 0" fxLayout="column" style="padding:2px">
                <span>{{task?.TaskName}}</span>
              </div>
              <div
                *ngIf="task?.displayBatteryVoltage == 1 && inspectionService.report?.header.title !== 'GM Express Inspection'"
                style="padding:4px;width:100%;">
                <div fxLayout="row" style="width:100%" fxFlex fxLayoutAlign="space-between center">
                  <span>{{task?.TaskName}}</span>
                  <span>{{task?.batteryVoltage}}v</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div fxLayout="column">
          <div id="tireSection">
            <span
              style="border-bottom:1px solid lightgray;font-size:16px;display:block;margin-top:16px; font-weight:bold; padding-right:20px">CHECK
              TIRES</span>
            <div class="flex flex-row w-full h-6 items-center"
              style="justify-content: space-around; background:rgba(233, 230, 230, 0.897); width: 100%;border-right: 1px solid lightgray;border-left: 1px solid lightgray;">
              <div class="flex flex-row justify-center items-center">Tread depth</div>
              <div class="flex flex-row justify-center items-center">
                <mat-icon class='mr-1' mat-font-set="material-icons" class="gm-mat-icon"
                  style="color:#00C853; margin:0 2px 0 0">
                  check_circle</mat-icon>
                <span>{{inspectionService.treadDepthSettings.greenTreadDepth}}/32 or greater</span>
              </div>
              <div class="flex flex-row justify-center items-center">
                <mat-icon class='mr-1' mat-font-set="material-icons" class="gm-mat-icon"
                  style="color:#FFD600; margin: 0 2px 0 0">
                  warning</mat-icon>
                <span>{{inspectionService.treadDepthSettings.yellowTreadDepth}}/32 to
                  {{inspectionService.treadDepthSettings.greenTreadDepth-1}}/32</span>
              </div>
              <div class="flex flex-row justify-center items-center">
                <mat-icon class='mr-1' mat-font-set="material-icons" class="gm-mat-icon"
                  style="color:#D50000; margin: 0 2px 0 0">
                  report</mat-icon>
                <span>{{inspectionService.treadDepthSettings.yellowTreadDepth-1}}/32 or less</span>
              </div>
            </div>
            <div fxLayout="row" style="border:1px solid lightgray; background:rgba(233, 230, 230, 0.897)">
              <div fxLayout="column" style="width:50%;border-right:1px solid darkgray">
                <div id="driverFront" fxLayout="column" style="margin:8px;">
                  <div fxLayout="row">
                    <span>Driver Front</span>
                  </div>
                  <div fxLayout="row" *ngIf="!inspectionService.report?.header.expressFlag">
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-2">psi before </span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLF.psiIn !== 0">{{inspectionService.report?.categories?.CheckTires.tasks.TiresLF.psiIn}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLF.psiIn === 0">--</span>
                      </div>
                    </div>
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-2">psi set to </span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLF.psiOut !== 0">{{inspectionService.report?.categories?.CheckTires.tasks.TiresLF.psiOut}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLF.psiOut === 0">--</span>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLF.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLF.color === 'Yellow'"
                        style="color:#FFD600; margin:0 2px 0 0">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLF.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLF.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Tread Depth</span>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTires.tasks.TiresLF.treadDepth}}/32</span>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <span fxLayout="row">Wear pattern/damage:</span>
                  </div>
                  <div fxLayout="row" style="border-bottom:1px solid darkgray;min-height:20px">
                    {{inspectionService.report?.categories?.CheckTires.tasks.TiresLF.wearPattern}}
                  </div>
                </div>
                <div id="driverRear" fxLayout="column" style="margin:8px;">
                  <div fxLayout="row">
                    <span>Driver Rear</span>
                  </div>
                  <div fxLayout="row" *ngIf="!inspectionService.report?.header.expressFlag">
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-2">psi before </span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLR.psiIn !== 0">{{inspectionService.report?.categories?.CheckTires.tasks.TiresLR.psiIn}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLR.psiIn === 0">--</span>
                      </div>
                    </div>
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-2">psi set to </span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLR.psiOut !== 0">{{inspectionService.report?.categories?.CheckTires.tasks.TiresLR.psiOut}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLR.psiOut === 0">--</span>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLR.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLR.color === 'Yellow'"
                        style="color:#FFD600; margin:0 2px 0 0">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLR.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresLR.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Tread Depth</span>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTires.tasks.TiresLR.treadDepth}}/32</span>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <span fxLayout="row">Wear pattern/damage:</span>
                  </div>
                  <div fxLayout="row" style="border-bottom:1px solid darkgray;min-height:20px">
                    {{inspectionService.report?.categories?.CheckTires.tasks.TiresLR.wearPattern}}
                  </div>
                </div>
                <!-- <div id="spareTire" *ngIf="!inspectionService.report?.header.expressFlag" fxLayout="column" style="margin:8px;">
                  <div fxLayout="row">
                    <span>Spare</span>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column">psi before </span>
                        <span fxLayout="column" *ngIf="inspectionService.report?.categories?.CheckTires.tasks.SpareTire.psiIn !== 0" >{{inspectionService.report?.categories?.CheckTires.tasks.SpareTire.psiIn}}</span>
                        <span fxLayout="column" *ngIf="inspectionService.report?.categories?.CheckTires.tasks.SpareTire.psiIn === 0" >--</span>
                      </div>
                    </div>
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column">psi set to </span>
                        <span fxLayout="column" *ngIf="inspectionService.report?.categories?.CheckTires.tasks.SpareTire.psiOut !== 0" >{{inspectionService.report?.categories?.CheckTires.tasks.SpareTire.psiOut}}</span>
                        <span fxLayout="column" *ngIf="inspectionService.report?.categories?.CheckTires.tasks.SpareTire.psiOut === 0" >--</span>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <span fxLayout="row">Wear pattern/damage:</span>
                  </div>
                  <div fxLayout="row" style="border-bottom:1px solid darkgray;min-height:20px">
                    {{inspectionService.report?.categories?.CheckTires.tasks.SpareTire.wearPattern}}
                  </div>
                </div> -->
                <div id="alignmentRotationReplacement" fxLayout="column" style="margin:8px;">
                  <div>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTires.tasks.Rotation.color === 'Green'"
                      style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTires.tasks.Rotation.color === 'Red'"
                      style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTires.tasks.Rotation.color === 'Grey'"
                      style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    <span
                      style="padding:2px">{{inspectionService.report?.categories?.CheckTires.tasks.Rotation.TaskName}}</span>
                  </div>
                  <div>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTires.tasks.Alignment.color === 'Green'"
                      style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTires.tasks.Alignment.color === 'Red'"
                      style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTires.tasks.Alignment.color === 'Grey'"
                      style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    <span
                      style="padding:2px">{{inspectionService.report?.categories?.CheckTires.tasks.Alignment.TaskName}}</span>
                  </div>
                  <div>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTires.tasks.Replacement.color === 'Green'"
                      style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTires.tasks.Replacement.color === 'Red'"
                      style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTires.tasks.Replacement.color === 'Grey'"
                      style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    <span
                      style="padding:2px">{{inspectionService.report?.categories?.CheckTires.tasks.Replacement.TaskName}}</span>
                  </div>
                </div>
              </div>
              <div fxLayout="column" style="width:50%">
                <div id="passengerFront" fxLayout="column" style="margin:8px;">
                  <div fxLayout="row">
                    <span>Passenger Front</span>
                  </div>
                  <div fxLayout="row" *ngIf="!inspectionService.report?.header.expressFlag">
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-2">psi before </span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRF.psiIn !== 0">
                          {{inspectionService.report?.categories?.CheckTires.tasks.TiresRF.psiIn}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRF.psiIn === 0">--</span>
                      </div>
                    </div>
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-2">psi set to </span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRF.psiOut !== 0">{{inspectionService.report?.categories?.CheckTires.tasks.TiresRF.psiOut}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRF.psiOut === 0"
                          style="width:30%">--</span>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRF.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRF.color === 'Yellow'"
                        style="color:#FFD600; margin:0 2px 0 0">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRF.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRF.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Tread Depth</span>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTires.tasks.TiresRF.treadDepth}}/32</span>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <span fxLayout="row">Wear pattern/damage:</span>
                  </div>
                  <div fxLayout="row" style="border-bottom:1px solid darkgray;min-height:20px">
                    {{inspectionService.report?.categories?.CheckTires.tasks.TiresRF.wearPattern}}
                  </div>
                </div>
                <div id="passengerRear" fxLayout="column" style="margin:8px;">
                  <div fxLayout="row">
                    <span>Passenger Rear</span>
                  </div>
                  <div fxLayout="row" *ngIf="!inspectionService.report?.header.expressFlag">
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-2">psi before </span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRR.psiIn !== 0">{{inspectionService.report?.categories?.CheckTires.tasks.TiresRR.psiIn}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRR.psiIn === 0">--</span>
                      </div>
                    </div>
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-2">psi set to </span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRR.psiOut !== 0">{{inspectionService.report?.categories?.CheckTires.tasks.TiresRR.psiOut}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRR.psiOut === 0"
                          style="width:30%">--</span>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRR.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRR.color === 'Yellow'"
                        style="color:#FFD600; margin:0 2px 0 0">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRR.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTires.tasks.TiresRR.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Tread Depth</span>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTires.tasks.TiresRR.treadDepth}}/32</span>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <span fxLayout="row">Wear pattern/damage:</span>
                  </div>
                  <div fxLayout="row" style="border-bottom:1px solid darkgray;min-height:20px">
                    {{inspectionService.report?.categories?.CheckTires.tasks.TiresRR.wearPattern}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="brakes">
            <span
              style="border-bottom:1px solid lightgray;font-size:16px;display:block;margin-top:16px; font-weight:bold">CHECK
              BRAKES</span>
            <div fxLayout="row" style="border:1px solid lightgray; background:rgba(233, 230, 230, 0.897)">
              <div fxLayout="column" style="width:36%;border-right:1px solid darkgray">
                <div id="frontBrakes" fxLayout="column" style="margin-left:8px; margin-top:8px">
                  <div fxLayout="row">
                    <span> Front Brakes</span>
                  </div>
                  <div id="driverFrontBrake" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesLF.color === 'Green'"
                        style="color:#00C853">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesLF.color === 'Yellow'"
                        style="color:#FFD600">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesLF.color === 'Red'"
                        style="color:#D50000">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesLF.color === 'Grey'"
                        style="color:#000000">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Driver front
                        {{inspectionService.report?.categories?.CheckBrakes.tasks.BrakesLF.brakeMeasurement}}</span>
                    </div>
                  </div>
                  <div id="passengerFrontBrake" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesRF.color === 'Green'"
                        style="color:#00C853">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesRF.color === 'Yellow'"
                        style="color:#FFD600">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesRF.color === 'Red'"
                        style="color:#D50000">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesRF.color === 'Grey'"
                        style="color:#000000">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Passenger front
                        {{inspectionService.report?.categories?.CheckBrakes.tasks.BrakesRF.brakeMeasurement}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div fxLayout="column" style="width:36%;border-right:1px solid darkgray">
                <div id="rearBrakes" fxLayout="column" style="margin-left:8px;margin-top:8px">
                  <div fxLayout="row">
                    <span> Rear Brakes</span>
                  </div>
                  <div id="driverRearBrake" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes?.tasks?.BrakesLR?.color === 'Green'"
                        style="color:#00C853">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes?.tasks?.BrakesLR?.color === 'Yellow'"
                        style="color:#FFD600">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes?.tasks?.BrakesLR?.color === 'Red'"
                        style="color:#D50000">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes?.tasks?.BrakesLR?.color === 'Grey'"
                        style="color:#000000">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Driver rear
                        {{inspectionService.report?.categories?.CheckBrakes.tasks.BrakesLR.brakeMeasurement}}</span>
                    </div>
                  </div>
                  <div id="passengerRearBrake" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesRR.color === 'Green'"
                        style="color:#00C853">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes?.tasks?.BrakesRR.color === 'Yellow'"
                        style="color:#FFD600">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesRR.color === 'Red'"
                        style="color:#D50000">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakes.tasks.BrakesRR.color === 'Grey'"
                        style="color:#000000">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Passenger rear
                        {{inspectionService.report?.categories?.CheckBrakes.tasks.BrakesRR.brakeMeasurement}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="additionalChecks">
            <span
              style="border-bottom:1px solid lightgray;font-size:16px;display:block;margin-top:16px; font-weight:bold">CHECKING
              FOLLOWING SYSTEM AND COMPONENTS</span>
            <div fxLayout="row">
              <div fxLayout="column" style="width:50%">
                <div
                  *ngFor="let task of inspectionService.report?.categories?.CheckFollowingSystemsComponents.leftColumn | orderBy : 'sequence'"
                  fxLayout="row">
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                    style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                    style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                    style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                    style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
                  <span style="padding:2px">{{task?.TaskName}}</span>
                </div>
              </div>
              <div fxLayout="column" style="width:50%">
                <div
                  *ngFor="let task of inspectionService.report?.categories?.CheckFollowingSystemsComponents.rightColumn | orderBy : 'sequence'"
                  fxLayout="row">
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                    style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                    style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                    style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                    style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
                  <span style="padding:2px">{{task?.TaskName}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<div class=" html2pdf__page-break"></div>-->

    <div style="page-break-before:always;margin:8px;position:relative;display:block; "
      *ngIf="inspectionService.report?.quoteLines?.length >  0" fxLayout="column">
      <div id="quoteHeader" style="margin-bottom:16px;">
        <h3 class="mat-headline" style="margin-bottom:8px;">Quote Details</h3>
        <hr class="hr-report">
      </div>
      <div id="quoteContainer">
        <div style="page-break-inside:avoid;margin-bottom:12px;position:relative;display:block;" *ngFor="let line
                            of inspectionService.report?.quoteLines | orderBy: [ 'Case']">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="column" fxLayoutAlign="center start">
              <span class="mat-subhead" style="text-decoration: underline; word-break: break-word">Case {{line.Case}}
                - {{line.TaskName}}</span>
              <span class="mat-caption" style="margin:2px 0px 2px 8px;">{{line.RecommendedHours}} Labour Hours
                -
                <i>Expires {{line.ExpirationDate | moment: 'MM.DD.YYYY'}}</i>
              </span>
              <span class="mat-caption" style="margin:2px 0px 2px 8px;">Employee: {{line.Employee}}</span>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="space-between center">
            <div fxFlex="65" fxLayoutAlign="start start" fxLayout="column">
              <div fxLayout="column">
                <span class="mat-body-2">
                  Concern
                </span>
                <span class="mat-caption" style="margin:2px 0px 2px 8px; word-break: break-word">{{line.Note ||
                  "Not Available" }}</span>
              </div>
              <div fxLayout="column">
                <span class="mat-body-2">
                  Cause
                </span>
                <span class="mat-caption" style="margin:2px 0px 2px 8px; word-break: break-word">{{line.Cause ||
                  "Not Available"}} </span>
              </div>
              <div fxLayout="column">
                <span class="mat-body-2">
                  Correction
                </span>
                <span class="mat-caption" style="margin:2px 0px 2px 8px; word-break: break-word;">{{line.Recommendation
                  ||
                  "Not Available "}}</span>
              </div>
            </div>
            <div fxFlex="30" fxLayout="row wrap" fxLayoutAlign="start start" style="margin-right:8px;">
              <div fxLayout="row" fxFlex="100">
                <span class="mat-body-2">Subtotals</span>
              </div>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px; ">
                <span class="mat-caption">Labour:</span>
                <span class="mat-caption">{{line.labourSubTotal | currency}}</span>
              </div>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px;">
                <span class="mat-caption">Parts:</span>
                <span class="mat-caption">{{line.partsSubTotal | currency}}</span>
              </div>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px;">
                <span class="mat-caption">Additional Charges:</span>
                <span class="mat-caption">{{line.additionalCharges | currency}} </span>
              </div>
              <div fxLayout="row" fxFlex="100 " fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px;">
                <span class="mat-caption">Tax:</span>
                <span class="mat-caption">{{line.tax | currency}}</span>
              </div>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center">
                <span class="mat-body-2">Total:</span>
                <span class="mat-body-2">{{line.CaseTotal| currency}}</span>
              </div>
            </div>
          </div>
          <mat-divider style="margin-top:8px;"></mat-divider>
        </div>
      </div>

      <div id="quoteTotal" fxLayout="column" fxLayoutAlign="center end" style="width:100%;">
        <span class="mat-subhead" style="font-weight:500;">Quote Total:
          {{getQuoteTotal(inspectionService.report?.quoteLines)
          | currency}} </span>
        <span class="mat-caption">*Shop supplies may apply.</span>
      </div>
    </div>

    <div *ngIf="this.inspectionService.bodyReportObject.signature"
      style="break-before:page;margin:8px;position:relative;display:block;">
      <inspection-body-report [printView]=true></inspection-body-report>
    </div>
  </div>
</div>